import { NgOptimizedImage } from "@angular/common";
import { Component } from "@angular/core";

import { ToolbarModule } from "primeng/toolbar";
import { RouterOutlet } from "@angular/router";

@Component({
  selector: "app-public-guide",
  imports: [ToolbarModule, NgOptimizedImage, RouterOutlet],
  templateUrl: "./public-guide.component.html",
  styleUrl: "./public-guide.component.scss",
})
export class PublicGuideComponent {}
